export function isMouseOnElement (element: HTMLElement | null, e: MouseEvent): boolean {
  if (element === null) {
    return false
  }

  const elementBoundary = element.getBoundingClientRect()
  return e.x >= elementBoundary.left && e.x <= elementBoundary.right && e.y >= elementBoundary.top && e.y <= elementBoundary.bottom
}
